var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container-app-search",
      attrs: { id: "form-search-popover" }
    },
    [
      _c(
        "div",
        {
          staticClass: "studio-page-header",
          class: { "studio-page-header-long": !_vm.is_sidebar_minimized }
        },
        [
          _c("h4", { staticClass: "title-tab-experience-manager" }, [
            _vm._v("DATA CONNECTIVITY")
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "custom-search",
              attrs: { slot: "beforeFilter" },
              slot: "beforeFilter"
            },
            [
              _c(
                "b-form",
                { attrs: { inline: "" } },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "btn grey btn-import-form m__r--5",
                      on: {
                        click: function($event) {
                          _vm.openModalDetail(null, "create")
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-plus fa-lg" }),
                      _vm._v(" Add\n        ")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form",
                    {
                      attrs: { inline: "" },
                      on: {
                        keypress: function($event) {
                          if (!("button" in $event) && $event.keyCode !== 13) {
                            return null
                          }
                          $event.preventDefault()
                          _vm.$refs.dataConnectivityTableComponent.setFilter(
                            _vm.filter_data
                          )
                        }
                      }
                    },
                    [
                      _c("j-select", {
                        staticClass: "m__r--5",
                        attrs: {
                          options: _vm.options_search,
                          "error-required": false,
                          placeholder: "Filter By"
                        },
                        model: {
                          value: _vm.select_type,
                          callback: function($$v) {
                            _vm.select_type = $$v
                          },
                          expression: "select_type"
                        }
                      }),
                      _vm._v(" "),
                      _vm.select_type === "created_at"
                        ? _c(
                            "span",
                            { staticClass: "date-filter m__r--5" },
                            [
                              _c("j-datepicker", {
                                staticClass: "m__r--5",
                                attrs: {
                                  "error-required": false,
                                  placeholder: "Start Date",
                                  format: "MMM dd, yyyy"
                                },
                                model: {
                                  value: _vm.filter_data_start_date,
                                  callback: function($$v) {
                                    _vm.filter_data_start_date = $$v
                                  },
                                  expression: "filter_data_start_date"
                                }
                              }),
                              _vm._v(" "),
                              _c("j-datepicker", {
                                attrs: {
                                  "disabled-dates": _vm.disableDates(
                                    _vm.filter_data_start_date
                                  ),
                                  "error-required": false,
                                  placeholder: "End Date",
                                  format: "MMM dd, yyyy"
                                },
                                model: {
                                  value: _vm.filter_data_end_date,
                                  callback: function($$v) {
                                    _vm.filter_data_end_date = $$v
                                  },
                                  expression: "filter_data_end_date"
                                }
                              })
                            ],
                            1
                          )
                        : _c("b-form-input", {
                            ref: "filterInput",
                            staticStyle: { width: "250px", height: "35px" },
                            attrs: { placeholder: "Search" },
                            model: {
                              value: _vm.filter_data,
                              callback: function($$v) {
                                _vm.filter_data = $$v
                              },
                              expression: "filter_data"
                            }
                          })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "studio-page-content" },
        [
          _c("v-server-table", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.load_first,
                expression: "load_first"
              }
            ],
            ref: "dataConnectivityTableComponent",
            staticClass: "jTable",
            attrs: { columns: _vm.columns, options: _vm.table_options },
            on: { loading: _vm.loading, loaded: _vm.loaded },
            scopedSlots: _vm._u([
              {
                key: "id",
                fn: function(props) {
                  return _c(
                    "div",
                    {
                      on: {
                        click: function($event) {
                          _vm.openModalDetail(props.row, "detail")
                        }
                      }
                    },
                    [_vm._v("\n        " + _vm._s(props.row.id) + "\n      ")]
                  )
                }
              },
              {
                key: "connection_name",
                fn: function(props) {
                  return _c(
                    "div",
                    {
                      on: {
                        click: function($event) {
                          _vm.openModalDetail(props.row, "detail")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.row.connection_name) +
                          "\n      "
                      )
                    ]
                  )
                }
              },
              {
                key: "database_driver",
                fn: function(props) {
                  return _c(
                    "div",
                    {
                      on: {
                        click: function($event) {
                          _vm.openModalDetail(props.row, "detail")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.row.database_driver) +
                          "\n      "
                      )
                    ]
                  )
                }
              },
              {
                key: "host",
                fn: function(props) {
                  return _c(
                    "div",
                    {
                      on: {
                        click: function($event) {
                          _vm.openModalDetail(props.row, "detail")
                        }
                      }
                    },
                    [_vm._v("\n        " + _vm._s(props.row.host) + "\n      ")]
                  )
                }
              },
              {
                key: "database",
                fn: function(props) {
                  return _c(
                    "div",
                    {
                      on: {
                        click: function($event) {
                          _vm.openModalDetail(props.row, "detail")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(props.row.database) + "\n      "
                      )
                    ]
                  )
                }
              },
              {
                key: "created_at",
                fn: function(props) {
                  return _c(
                    "div",
                    {
                      on: {
                        click: function($event) {
                          _vm.openModalDetail(props.row, "detail")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.convertDate(props.row.created_at)) +
                          "\n      "
                      )
                    ]
                  )
                }
              }
            ])
          }),
          _vm._v(" "),
          !_vm.load_first ? _c("jLoadingTable") : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalDetailDataConnectivity",
          staticClass: "mod-form modal-form-ui",
          attrs: {
            centered: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [
          _c("div", [
            _c("div", { staticClass: "modal-title-jdc" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.mode === "edit" ? "Detail" : "Add") +
                  " Connection "
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sub-container" },
              [
                _c("div", { staticClass: "circle-border" }, [
                  _vm._v("\n          1\n        ")
                ]),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c("b-col", { attrs: { cols: "12" } }, [
                      _c("label", [_vm._v(" Database Driver ")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex flex-wrap align-items-center" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "driver_options",
                              class: {
                                "driver-img-selected":
                                  _vm.dataConnectivity.database_driver ===
                                  "mysql",
                                "error-border":
                                  _vm.$v.dataConnectivity.database_driver.$error
                              },
                              on: {
                                click: function($event) {
                                  _vm.changeDatabaseDriver("mysql")
                                }
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "driver-img",
                                attrs: {
                                  src: require("@/assets/logo/db-driver/mysql.png"),
                                  alt: "mysql"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "driver_options",
                              class: {
                                "driver-img-selected":
                                  _vm.dataConnectivity.database_driver ===
                                  "postgres",
                                "error-border":
                                  _vm.$v.dataConnectivity.database_driver.$error
                              },
                              on: {
                                click: function($event) {
                                  _vm.changeDatabaseDriver("postgres")
                                }
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "driver-img",
                                attrs: {
                                  src: require("@/assets/logo/db-driver/postgress.png"),
                                  alt: "postgress"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "driver_options",
                              class: {
                                "driver-img-selected":
                                  _vm.dataConnectivity.database_driver ===
                                  "sqlserver",
                                "error-border":
                                  _vm.$v.dataConnectivity.database_driver.$error
                              },
                              on: {
                                click: function($event) {
                                  _vm.changeDatabaseDriver("sqlserver")
                                }
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "driver-img",
                                attrs: {
                                  src: require("@/assets/logo/db-driver/sqlserver.png"),
                                  alt: "sqlserver"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "driver_options",
                              class: {
                                "driver-img-selected":
                                  _vm.dataConnectivity.database_driver ===
                                  "graph",
                                "error-border":
                                  _vm.$v.dataConnectivity.database_driver.$error
                              },
                              on: {
                                click: function($event) {
                                  _vm.changeDatabaseDriver("graph")
                                }
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "driver-img-graph",
                                attrs: {
                                  src: require("@/assets/logo/db-driver/graph.svg"),
                                  alt: "graph"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "driver_options",
                              class: {
                                "driver-img-selected":
                                  _vm.dataConnectivity.database_driver ===
                                  "clickhouse",
                                "error-border":
                                  _vm.$v.dataConnectivity.database_driver.$error
                              },
                              on: {
                                click: function($event) {
                                  _vm.changeDatabaseDriver("clickhouse")
                                }
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "driver-img",
                                attrs: {
                                  src: require("@/assets/logo/db-driver/clickhouse.svg"),
                                  alt: "clickhouse"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "driver_options",
                              class: {
                                "driver-img-selected":
                                  _vm.dataConnectivity.database_driver ===
                                  "oracle",
                                "error-border":
                                  _vm.$v.dataConnectivity.database_driver.$error
                              },
                              on: {
                                click: function($event) {
                                  _vm.changeDatabaseDriver("oracle")
                                }
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "driver-img",
                                attrs: {
                                  src: require("@/assets/logo/db-driver/oracle.png"),
                                  alt: "oracle"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "driver_options driver-img-disabled",
                              class: {
                                "driver-img-selected":
                                  _vm.dataConnectivity.database_driver ===
                                  "db2",
                                "error-border":
                                  _vm.$v.dataConnectivity.database_driver.$error
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "driver-img",
                                attrs: {
                                  src: require("@/assets/logo/db-driver/db2.png"),
                                  alt: "db2"
                                }
                              })
                            ]
                          )
                        ]
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c("b-col", { attrs: { cols: "12" } }, [
                      _c(
                        "div",
                        [
                          _c(
                            "b-form-group",
                            {
                              class: {
                                "error-input":
                                  _vm.$v.dataConnectivity.connection_name.$error
                              }
                            },
                            [
                              _c("label", { attrs: { for: "name" } }, [
                                _vm._v(" Connection Name ")
                              ]),
                              _vm._v(" "),
                              _c("j-input", {
                                attrs: {
                                  "error-required":
                                    _vm.$v.dataConnectivity.connection_name
                                      .$error,
                                  disabled: _vm.mode == "edit",
                                  "error-message": _vm.error_minimum_connection_name
                                    ? "Minimum 8 Character"
                                    : "Field is required",
                                  placeholder: "Enter connection name here"
                                },
                                model: {
                                  value: _vm.dataConnectivity.connection_name,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.dataConnectivity,
                                      "connection_name",
                                      $$v
                                    )
                                  },
                                  expression: "dataConnectivity.connection_name"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.dataConnectivity.database_driver !== "graph"
                            ? _c(
                                "b-form-group",
                                {
                                  staticClass: "m__t--7",
                                  class: {
                                    "error-input":
                                      _vm.$v.dataConnectivity.connection_method
                                        .$error
                                  }
                                },
                                [
                                  _c("label", { attrs: { for: "name" } }, [
                                    _vm._v(" Connection Method ")
                                  ]),
                                  _vm._v(" "),
                                  _c("j-single-select", {
                                    attrs: {
                                      options: _vm.listConnectionTypeTable,
                                      disabled:
                                        _vm.mode == "edit" ||
                                        _vm.dataConnectivity.database_driver ===
                                          "clickhouse" ||
                                        _vm.dataConnectivity.database_driver ===
                                          "oracle",
                                      "error-required":
                                        _vm.$v.dataConnectivity
                                          .connection_method.$error,
                                      placeholder:
                                        "Select connection method here",
                                      label: "text"
                                    },
                                    model: {
                                      value:
                                        _vm.dataConnectivity.connection_method,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.dataConnectivity,
                                          "connection_method",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "dataConnectivity.connection_method"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.dataConnectivity.database_driver === "oracle"
                            ? _c(
                                "b-form-group",
                                {
                                  class: {
                                    "error-input":
                                      _vm.$v.dataConnectivity.service_name
                                        .$error
                                  }
                                },
                                [
                                  _c("label", { attrs: { for: "name" } }, [
                                    _vm._v(" Service Name ")
                                  ]),
                                  _vm._v(" "),
                                  _c("j-input", {
                                    attrs: {
                                      "error-required":
                                        _vm.$v.dataConnectivity.service_name
                                          .$error,
                                      disabled: _vm.mode == "edit",
                                      placeholder: "Enter service name here"
                                    },
                                    model: {
                                      value: _vm.dataConnectivity.service_name,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.dataConnectivity,
                                          "service_name",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "dataConnectivity.service_name"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.dataConnectivity.database_driver === "postgres"
                            ? _c(
                                "b-form-group",
                                {
                                  class: {
                                    "error-input":
                                      _vm.$v.dataConnectivity.database.$error
                                  }
                                },
                                [
                                  _c("label", { attrs: { for: "name" } }, [
                                    _vm._v(" Database ")
                                  ]),
                                  _vm._v(" "),
                                  _c("j-input", {
                                    attrs: {
                                      disabled: _vm.mode == "edit",
                                      "error-required":
                                        _vm.$v.dataConnectivity.database.$error,
                                      placeholder: "Enter database"
                                    },
                                    model: {
                                      value: _vm.dataConnectivity.database,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.dataConnectivity,
                                          "database",
                                          $$v
                                        )
                                      },
                                      expression: "dataConnectivity.database"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.dataConnectivity.database_driver === "postgres"
                            ? _c(
                                "b-form-group",
                                {
                                  class: {
                                    "error-input":
                                      _vm.$v.dataConnectivity.schema.$error
                                  }
                                },
                                [
                                  _c("label", { attrs: { for: "name" } }, [
                                    _vm._v(" Schema ")
                                  ]),
                                  _vm._v(" "),
                                  _c("j-input", {
                                    attrs: {
                                      disabled: _vm.mode == "edit",
                                      "error-required":
                                        _vm.$v.dataConnectivity.schema.$error,
                                      placeholder: "Enter schema path"
                                    },
                                    model: {
                                      value: _vm.dataConnectivity.schema,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.dataConnectivity,
                                          "schema",
                                          $$v
                                        )
                                      },
                                      expression: "dataConnectivity.schema"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.dataConnectivity.connection_method === "tcp-ssh"
                  ? _c("label", { staticClass: "m__t--20" }, [
                      _vm._v("SSH Server")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.dataConnectivity.connection_method === "tcp-ssh"
                  ? _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "8" } }, [
                          _c(
                            "div",
                            [
                              _c(
                                "b-form-group",
                                {
                                  class: {
                                    "error-input":
                                      _vm.$v.dataConnectivity.ssh_host.$error
                                  }
                                },
                                [
                                  _c("label", { attrs: { for: "name" } }, [
                                    _vm._v(" Host ")
                                  ]),
                                  _vm._v(" "),
                                  _c("j-input", {
                                    attrs: {
                                      disabled: _vm.mode == "edit",
                                      "error-required":
                                        _vm.$v.dataConnectivity.ssh_host.$error,
                                      placeholder: "Enter host here"
                                    },
                                    model: {
                                      value: _vm.dataConnectivity.ssh_host,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.dataConnectivity,
                                          "ssh_host",
                                          $$v
                                        )
                                      },
                                      expression: "dataConnectivity.ssh_host"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "4" } }, [
                          _c(
                            "div",
                            [
                              _c(
                                "b-form-group",
                                {
                                  class: {
                                    "error-input":
                                      _vm.$v.dataConnectivity.ssh_port.$error
                                  }
                                },
                                [
                                  _c("label", { attrs: { for: "name" } }, [
                                    _vm._v(" Port ")
                                  ]),
                                  _vm._v(" "),
                                  _c("j-input", {
                                    attrs: {
                                      disabled: _vm.mode == "edit",
                                      "error-required":
                                        _vm.$v.dataConnectivity.ssh_port.$error,
                                      placeholder: "22"
                                    },
                                    model: {
                                      value: _vm.dataConnectivity.ssh_port,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.dataConnectivity,
                                          "ssh_port",
                                          $$v
                                        )
                                      },
                                      expression: "dataConnectivity.ssh_port"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.dataConnectivity.connection_method === "tcp-ssh"
                  ? _c(
                      "b-row",
                      { staticClass: "m__t--7" },
                      [
                        _c("b-col", { attrs: { cols: "6" } }, [
                          _c(
                            "div",
                            [
                              _c(
                                "b-form-group",
                                {
                                  class: {
                                    "error-input":
                                      _vm.$v.dataConnectivity.ssh_username
                                        .$error
                                  }
                                },
                                [
                                  _c("label", { attrs: { for: "name" } }, [
                                    _vm._v(" Username ")
                                  ]),
                                  _vm._v(" "),
                                  _c("j-input", {
                                    attrs: {
                                      disabled: _vm.mode == "edit",
                                      "error-required":
                                        _vm.$v.dataConnectivity.ssh_username
                                          .$error,
                                      placeholder: "Enter username here"
                                    },
                                    model: {
                                      value: _vm.dataConnectivity.ssh_username,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.dataConnectivity,
                                          "ssh_username",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "dataConnectivity.ssh_username"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "6" } }, [
                          _c(
                            "div",
                            [
                              _c(
                                "b-form-group",
                                {
                                  class: {
                                    "error-input":
                                      _vm.$v.dataConnectivity.ssh_password
                                        .$error
                                  }
                                },
                                [
                                  _c("label", { attrs: { for: "name" } }, [
                                    _vm._v(" Password ")
                                  ]),
                                  _vm._v(" "),
                                  _c("j-input", {
                                    attrs: {
                                      id: "passord",
                                      disabled: _vm.mode == "edit",
                                      "error-required":
                                        _vm.$v.dataConnectivity.ssh_password
                                          .$error,
                                      type: "password",
                                      placeholder: "*************"
                                    },
                                    model: {
                                      value: _vm.dataConnectivity.ssh_password,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.dataConnectivity,
                                          "ssh_password",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "dataConnectivity.ssh_password"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("label", { staticClass: "m__t--20" }, [
                  _vm._v("Database Server")
                ]),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c("b-col", { attrs: { cols: "8" } }, [
                      _c(
                        "div",
                        [
                          _c(
                            "b-form-group",
                            {
                              class: {
                                "error-input":
                                  _vm.$v.dataConnectivity.host.$error
                              }
                            },
                            [
                              _c("label", { attrs: { for: "name" } }, [
                                _vm._v(" Host ")
                              ]),
                              _vm._v(" "),
                              _c("j-input", {
                                attrs: {
                                  disabled: _vm.mode == "edit",
                                  "error-required":
                                    _vm.$v.dataConnectivity.host.$error,
                                  placeholder: "Enter host here"
                                },
                                model: {
                                  value: _vm.dataConnectivity.host,
                                  callback: function($$v) {
                                    _vm.$set(_vm.dataConnectivity, "host", $$v)
                                  },
                                  expression: "dataConnectivity.host"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("b-col", { attrs: { cols: "4" } }, [
                      _c(
                        "div",
                        [
                          _c(
                            "b-form-group",
                            {
                              class: {
                                "error-input":
                                  _vm.$v.dataConnectivity.port.$error
                              }
                            },
                            [
                              _c("label", { attrs: { for: "name" } }, [
                                _vm._v(" Port ")
                              ]),
                              _vm._v(" "),
                              _c("j-input", {
                                attrs: {
                                  disabled: _vm.mode == "edit",
                                  "error-required":
                                    _vm.$v.dataConnectivity.port.$error,
                                  placeholder: "Enter port here"
                                },
                                model: {
                                  value: _vm.dataConnectivity.port,
                                  callback: function($$v) {
                                    _vm.$set(_vm.dataConnectivity, "port", $$v)
                                  },
                                  expression: "dataConnectivity.port"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  { staticClass: "m__t--7" },
                  [
                    _c("b-col", { attrs: { cols: "6" } }, [
                      _c(
                        "div",
                        [
                          _c(
                            "b-form-group",
                            {
                              class: {
                                "error-input":
                                  _vm.$v.dataConnectivity.username.$error
                              }
                            },
                            [
                              _c("label", { attrs: { for: "name" } }, [
                                _vm._v(" Username ")
                              ]),
                              _vm._v(" "),
                              _c("j-input", {
                                attrs: {
                                  disabled: _vm.mode == "edit",
                                  "error-required":
                                    _vm.$v.dataConnectivity.username.$error,
                                  placeholder: "Enter username here"
                                },
                                model: {
                                  value: _vm.dataConnectivity.username,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.dataConnectivity,
                                      "username",
                                      $$v
                                    )
                                  },
                                  expression: "dataConnectivity.username"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("b-col", { attrs: { cols: "6" } }, [
                      _c(
                        "div",
                        [
                          _c(
                            "b-form-group",
                            {
                              class: {
                                "error-input":
                                  _vm.$v.dataConnectivity.password.$error
                              }
                            },
                            [
                              _c("label", { attrs: { for: "name" } }, [
                                _vm._v(" Password ")
                              ]),
                              _vm._v(" "),
                              _c("j-input", {
                                attrs: {
                                  id: "passord",
                                  disabled: _vm.mode == "edit",
                                  "error-required":
                                    _vm.$v.dataConnectivity.password.$error,
                                  type: "password",
                                  placeholder: "*************"
                                },
                                model: {
                                  value: _vm.dataConnectivity.password,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.dataConnectivity,
                                      "password",
                                      $$v
                                    )
                                  },
                                  expression: "dataConnectivity.password"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.mode == "create",
                        expression: "mode == 'create'"
                      }
                    ],
                    staticClass: "m__t--10"
                  },
                  [
                    _c("b-col", [
                      _c("div", [
                        _c(
                          "div",
                          { staticClass: "float-right" },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "btn",
                                attrs: {
                                  id: "btn-verify",
                                  variant: "outline-primary"
                                },
                                on: { click: _vm.verifyDataConnection }
                              },
                              [
                                _vm._v(
                                  "\n                  Verify\n                "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.listDatabaseOptions.length != 0 &&
            _vm.dataConnectivity.database_driver !== "graph" &&
            _vm.dataConnectivity.database_driver !== "oracle"
              ? _c(
                  "div",
                  { staticClass: "sub-container" },
                  [
                    _c("div", { staticClass: "circle-border" }, [
                      _vm._v("\n          2\n        ")
                    ]),
                    _vm._v(" "),
                    _c("h4", [_vm._v("Default Scheme")]),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "12" } }, [
                          _c(
                            "div",
                            [
                              _c(
                                "b-form-group",
                                {
                                  class: {
                                    "error-input":
                                      _vm.$v.dataConnectivity.database.$error
                                  }
                                },
                                [
                                  _c("label", { attrs: { for: "name" } }, [
                                    _vm._v(" Database ")
                                  ]),
                                  _vm._v(" "),
                                  _c("j-single-select", {
                                    attrs: {
                                      options: _vm.listDatabaseOptions,
                                      disabled:
                                        _vm.mode == "edit" ||
                                        (_vm.mode === "create" &&
                                          _vm.dataConnectivity
                                            .database_driver === "postgres"),
                                      "error-required":
                                        _vm.$v.dataConnectivity.database.$error,
                                      placeholder: "Select database here",
                                      label: "text"
                                    },
                                    model: {
                                      value: _vm.dataConnectivity.database,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.dataConnectivity,
                                          "database",
                                          $$v
                                        )
                                      },
                                      expression: "dataConnectivity.database"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "m__t--10" },
              [
                _vm.mode == "edit"
                  ? _c(
                      "b-button",
                      {
                        staticClass: "btn red",
                        on: {
                          click: function($event) {
                            _vm.deleteDataConnectiion(_vm.dataConnectivity.id)
                          }
                        }
                      },
                      [_vm._v("\n          Delete\n        ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "float-right" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn btn-jdc white",
                        on: { click: _vm.closeModalDetail }
                      },
                      [_vm._v("\n            Close\n          ")]
                    ),
                    _vm._v(" "),
                    _vm.mode != "edit"
                      ? _c(
                          "b-button",
                          {
                            staticClass: "btn btn-jdc blue m__l--5",
                            on: { click: _vm.setDataConnection }
                          },
                          [_vm._v("\n            Save\n          ")]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d9a57c6c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9a57c6c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/data-connectivity/jDataConnectivityList.vue
// module id = null
// module chunks = 